import React, { useState } from "react";
import "./Tooltip.css";

/**
 * GenericTooltip — adapted from aichat-frontend/src/components/GenericTooltip
 * Shows a tooltip on hover with multiline support.
 *
 * Props:
 *  tooltipText      - string to display inside tooltip
 *  tooltipPosition  - "top" | "bottom" | "left" | "right" (default: "bottom")
 *  children         - the element to wrap
 *  className        - optional extra class on the wrapper
 */
const Tooltip = ({
  tooltipText,
  tooltipPosition = "bottom",
  children,
  className = "",
}) => {
  const [isVisible, setIsVisible] = useState(false);

  return (
    <span
      className={`tooltip-container ${className}`}
      onMouseEnter={() => setIsVisible(true)}
      onMouseLeave={() => setIsVisible(false)}
      onFocus={() => setIsVisible(true)}
      onBlur={() => setIsVisible(false)}
    >
      {children}
      {isVisible && tooltipText && (
        <span className={`tooltip-box position-${tooltipPosition}`}>
          {tooltipText.split("\n").map((line, index) => (
            <span key={index} className="tooltip-line">
              {line}
            </span>
          ))}
        </span>
      )}
    </span>
  );
};

export default Tooltip;
